<template>
  <div
    class="sheet-panel user-persona"
    :class="{ 'panel-link': link }"
    @click="viewPersona(personality.persona)"
  >
    <div class="sheet-header" v-if="firstName || lastName">
      <h3>{{ firstName }} {{ lastName }}</h3>
    </div>
    <div class="sheet-content">
      <img
        :src="
          'https://cdn.traitstack.com/static/' +
            personas[personality.persona].image
        "
        class="persona-image"
      />
      <div class="h3 blue text-center">
        {{ personas[personality.persona].title }}
      </div>
      <div v-if="!link" class="tags text-center">
        <div
          class="tag"
          v-bind:key="tag"
          v-for="tag in personas[personality.persona].tags"
        >
          {{ tag }}
        </div>
      </div>
      <p>
        {{ personas[personality.persona].description }}
      </p>
    </div>
  </div>
</template>
<script>
import { personas, reporting } from "@/assets/static.js";
export default {
  props: {
    firstName: String,
    lastName: String,
    personality: Object,
    link: Boolean,
  },
  data() {
    return {
      personas: personas,
      reporting: reporting,
    };
  },
  methods: {
    viewPersona(persona) {
      if (this.link) {
        this.$router.push({
          path: "/results/insights/?persona=" + persona,
        });
      }
    },
  },
};
</script>
